import { render, staticRenderFns } from "./AccessibilityBanner.vue?vue&type=template&id=69c79a65&scoped=true&"
import script from "./AccessibilityBanner.vue?vue&type=script&lang=js&"
export * from "./AccessibilityBanner.vue?vue&type=script&lang=js&"
import style0 from "./AccessibilityBanner.vue?vue&type=style&index=0&id=69c79a65&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69c79a65",
  null
  
)

export default component.exports